import { Badge, Box, HStack, Text, VStack } from '@chakra-ui/react'
import { RESULT_STATUS_LABELS, type ResultStatus } from '../../../../types/script'
import type { ContactDetail } from '../../../../types/contactDetail'

export const shortDay = (iso: string) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })

/** [Spec §4.7] Past visits and tag events, newest first. Neutral colours: the walk's status vocabulary owns colour. */
export function HistorySection({ detail }: { detail: ContactDetail }) {
  const events = [
    ...detail.canvassingSessions.map(s => ({ kind: 'visit' as const, date: s.sessionDate, s })),
    ...detail.tags.map(t => ({ kind: 'tag' as const, date: t.assignedDate, t })),
  ].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  if (events.length === 0) return <Text fontSize="sm" color="fg.muted">No visits or tags yet.</Text>
  return (
    <VStack align="stretch" gap={2}>
      {events.map(e => e.kind === 'visit' ? (
        <Box key={`v-${e.s.id}`} p={3} borderWidth="1px" borderColor="border" borderRadius="md">
          <HStack justify="space-between">
            <Badge bg="bg.subtle" color="fg">{RESULT_STATUS_LABELS[e.s.resultStatus as ResultStatus] ?? e.s.resultStatus}</Badge>
            <Text fontSize="xs" color="fg.muted">{shortDay(e.s.sessionDate)}</Text>
          </HStack>
          <Text fontSize="xs" color="fg.muted" mt={1}>{`by ${e.s.canvasserName}${e.s.scriptName ? ` · ${e.s.scriptName}` : ''}`}</Text>
          {e.s.notes && <Text fontSize="sm" mt={1}>{e.s.notes}</Text>}
          {e.s.surveyResponses.map(r => (
            <HStack key={r.id} justify="space-between" fontSize="xs" mt={1}>
              <Text color="fg.muted" lineClamp={1} flex={1}>{r.questionLabel}</Text>
              <Text fontWeight="medium">{r.answerText || r.responseText || '-'}</Text>
            </HStack>
          ))}
        </Box>
      ) : (
        <HStack key={`t-${e.t.id}`} justify="space-between" px={1}>
          <Text fontSize="sm">{`Tag added: ${e.t.label}`}</Text>
          <Text fontSize="xs" color="fg.muted">{shortDay(e.t.assignedDate)}</Text>
        </HStack>
      ))}
    </VStack>
  )
}
